import styled from 'styled-components'

export const ListWrapper = styled.section``

export { Header, Title, Navigation, List, NoResults, LoadMore } from 'components/Catalog/catalog.styles'
